import { HubJsonRpcRequest } from '../api/HubJsonRpcRequest';
import { HubApiMethods } from '../constants/HubApiMethods';
import { CustomJrpcErrResult } from '../general/modules/jsonRpc/jRpcErrResponse';
import {
    GetLinkedAccountsInfoRequest,
    GetLinkedAccountsInfoResponse
} from './tethers-types';

export class Tethers {
    public static async getLinkedAccountsInfo(suid:string, token: string): Promise<
        GetLinkedAccountsInfoResponse|CustomJrpcErrResult
    > {
        const request: GetLinkedAccountsInfoRequest = {
            suid,
            token
        };
        const response = await HubJsonRpcRequest.makeRequest<
            GetLinkedAccountsInfoResponse,
            GetLinkedAccountsInfoRequest
            >(HubApiMethods.GET_LINKED_ACCOUNTS_INFO, request, window.app.deviceIdentifier);

        if ('error' in response) {
            return null;
        }

        return response;
    }
}
